import React from "react";
import CinRightIpad from "./CinRightIpad";
import AddCinLeft from "./AddCinLeft";
import Navbar from "../../../../Navbar/Navbar";

const AddCin = () => {
  return (
    <>
      <Navbar />
      <div className="mt-5"></div>
      <div className="row">
        <div className="col-12 col-lg-5 ">
          <AddCinLeft />
        </div>
        <CinRightIpad />
      </div>
    </>
  );
};

export default AddCin;
